/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotodone3Inputs */

const en_aiflowphotodone3 = /** @type {(inputs: Aiflowphotodone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done. Text and logo sit in the same place in every format. Everything is in your media library too.`)
};

const de_aiflowphotodone3 = /** @type {(inputs: Aiflowphotodone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig. Text und Logo sitzen in jedem Format an der gleichen Stelle. Alles liegt auch in deiner Mediathek.`)
};

/**
* | output |
* | --- |
* | "Done. Text and logo sit in the same place in every format. Everything is in your media library too." |
*
* @param {Aiflowphotodone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotodone3 = /** @type {((inputs?: Aiflowphotodone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotodone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotodone3(inputs)
	return de_aiflowphotodone3(inputs)
});
export { aiflowphotodone3 as "aiFlowPhotoDone" }